import script from "./pop-up-username.vue?vue&type=script&setup=true&lang=js"
export * from "./pop-up-username.vue?vue&type=script&setup=true&lang=js"

import "./pop-up-username.vue?vue&type=style&index=0&id=34f60b62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34f60b62"]])

export default __exports__